export const CLUBS_ORDER = [
  'Driver', '3-Wood', '4-Wood', '5-Wood', '6-Wood', '7-Wood', '8-Wood', '9-Wood',
  '1-Iron', '2-Iron', '3-Iron', '4-Iron',
  '2-Hybrid', '3-Hybrid', '4-Hybrid', '5-Hybrid', '6-Hybrid',
  '5-Iron', '6-Iron', '7-Iron', '8-Iron', '9-Iron',
  'Pitching Wedge', 'Gap Wedge', 'Sand Wedge', 'Lob Wedge',
  'Putter'
];

export const SIDEBAR_ORDER = ['General', 'Driver', 'Fairway Woods', 'Utilities', 'Irons', 'Wedges', 'Putter', 'Ball'];

export const SIDEBAR_CATEGORIES: Record<string, string[]> = {
  'General': ['general'], // Special case for the general profile section
  'Driver': ['Driver'],
  'Fairway Woods': ['3-Wood', '4-Wood', '5-Wood', '6-Wood', '7-Wood', '8-Wood', '9-Wood'],
  'Utilities': ['1-Iron', '2-Iron', '2-Hybrid', '3-Hybrid', '4-Hybrid', '5-Hybrid', '6-Hybrid'],
  'Irons': ['3-Iron', '4-Iron', '5-Iron', '6-Iron', '7-Iron', '8-Iron', '9-Iron', 'Pitching Wedge'],
  'Wedges': ['Gap Wedge', 'Sand Wedge', 'Lob Wedge'],
  'Putter': ['Putter'],
  'Ball': ['Ball']
};

// Affiliate tracking URLs
export const AFFILIATE_TRACKING_URLS = {
  PGA_TOUR_SUPERSTORE: 'https://pga-tour-superstore.pxf.io/c/6401536/1414697/16839',
  GLOBAL_GOLF: 'https://globalgolf.pxf.io/c/6401536/1242437/15291',
  EBAY: 'https://www.ebay.com/sch/i.html',
  AWIN_MASTERTAG: 'https://www.dwin2.com/pub.2606376.min.js'
} as const;
